import {
  IAnalytics,
  REPORTTYPE_IAS_DEVICE,
  REPORTTYPE_IAS_FIRST_PARTY,
  REPORTTYPE_IAS_PERFORMANCE,
  REPORTTYPE_IAS_THIRD_PARTY,
  REPORTTYPE_IAS_YOUTUBE,
  transformAnalytics,
  v1SettingsPost,
} from '~/src/dash/api/console-api';
import { EBool } from '~/src/dash/api/types/bool';

export interface IIASDashboardTableFilterConfig {
  AdvertiserID?: string;
  CreativeID?: string;
  Line_ItemID?: string;
  OrderID?: string;
  [key: string]: any;
}

export interface IIASFirstAndThirdPartyRequestBody {
  Debug?: boolean;
  GraphID: string;
  ReportName?: string;
  TeamID: string;
  Email?: string;
  ReportID?: string;
  TeamName?: string;
  Recipients?: string[];

  StartDate: string;
  EndDate: string;
  GroupingNumber: number;
  Timezone: string;

  GroupBys?: string[];
  Metrics?: string[];

  // Where
  PublicaChannelIDs: number[];
  PublicaBidderIDs: number[];
  IsBidderIDsIncluded: EBool;
  PublicaBidderGroupIDs: number[];
  PublicaBidderTypes: string[];
  AnIDs: number[];
  DeviceTypes: number[];
  GroupByKey?: string;

  Filters?: IIASDashboardTableFilterConfig;

  AdvertiserIDs?: string[];
  OrderIDs?: string[];
  LineItemIDs?: string[];
  CreativeIDs?: string[];
  AdUnitIDs?: string[];

  ReportOrderBy?: string;
  ReportOrderByKey?: string;
  ReportLimit?: number;

  // Search
  NameSearch?: string;
  IDSearch?: string;

  // Pagination
  Page?: number;
  PageSize?: number;

  Priority?: string;
}

export interface IIASFirstAndThirdPartyAnalytics {
  Date: string;
  EligibleAds: number;
  Impressions: number;
  TrackedAds: number;
  Quartile1: number;
  Quartile2: number;
  Quartile3: number;
  Completes: number;
  OnScreenCompletes: number;
  RenderedImpressions: number;
  ViewableImpressions: number;
  NonViewableImpression: number;
  ViewableQuartile1: number;
  ViewableQuartile2: number;
  ViewableQuartile3: number;
  ViewableCompletes: number;
  MeasuredAds: number;
  IVTAds: number;
  GIVTAds: number;
  SIVTAds: number;
  ValidVideoAds: number;
  PassedImps: number;
  FailedImps: number;
  UnmeasuredImps: number;
  Quartile1Rate: number;
  Quartile2Rate: number;
  Quartile3Rate: number;
  CompletionRate: number;
  IVTRate: number;
  IVTCount: number;
  IVTBlockRate: number;
  IVTBlockCount: number;
  ValidCompletionRate: number;
  OnScreenCompletionRate: number;
  MeasuredRate: number;
  ViewabilityRate: number;
  NonViewableImpRate: number;
  ViewableQuartile1Rate: number;
  ViewableQuartile2Rate: number;
  ViewableQuartile3Rate: number;
  ViewableCompleteRate: number;
  ValidTrafficRate: number;
  AppExclusionListBlockRate: number;
  AppExclusionListBlockCount: number;
  FailedAdRate: number;
  FailedAdCount: number;
  URLFailRate: number;
  IVTFailRate: number;
  AdBlockRate: number;
  AdBlockCount: number;
  FilledCount: number;
  RequestCount: number;
  RenderRate: number;
  GIVTRate: number;
  SIVT_RATE: number;
  PassRate: number;
  UnmeasuredImpRate: number;
  AudibleViewableCustomQ2: number;
  AudibleViewableIndStdQ4: number;
  AVOCGroupMRate: number;
  AVOCRate: number;
  GrossImps: number;
  MeasuredImps: number;
  MobileGrossImps: number;
  MeasuredRenderedImps: number;
  MeasuredGivtRenderedImps: number;
  MeasuredSivtRenderedImps: number;
  RenderedImps: number;
  GivtImps: number;
  SivtImps: number;
  GivtRenderedImps: number;
  SivtRenderedImps: number;
  InViewGivtRenderedImps: number;
  InViewSivtRenderedImps: number;
  InViewRenderedImps: number;
  BlockedImps: number;
  TotalImps: number;
  SuspiciousImps: number;
  MobileTotalImps: number;
  MobileRenderedImps: number;
}

export interface IIASFirstAndThirdPartyResponse {
  rows: [IAnalytics];
  timings: {
    preprocessing: number;
    preprocessing_str: string;
    query: number;
    query_str: string;
    postprocessing: number;
    postprocessing_str: string;
  };
  debug: boolean;
}

export function isIASReport(reportType: string): boolean {
  return (
    reportType === REPORTTYPE_IAS_THIRD_PARTY ||
    reportType === REPORTTYPE_IAS_FIRST_PARTY ||
    reportType === REPORTTYPE_IAS_PERFORMANCE ||
    reportType === REPORTTYPE_IAS_DEVICE ||
    reportType === REPORTTYPE_IAS_YOUTUBE
  );
}

export async function queryFirstAndThirdPartyIasData(
  body: IIASFirstAndThirdPartyRequestBody,
  queryParams: { [key: string]: any },
): Promise<[IIASFirstAndThirdPartyResponse?, Error?]> {
  return await v1SettingsPost('/ias_first_and_third_party_data', body, queryParams);
}

export async function getFirstAndThirdPartyIasData(
  body: IIASFirstAndThirdPartyRequestBody,
  queryParams: { [key: string]: any },
): Promise<[IAnalytics[], number, string]> {
  const response = await queryFirstAndThirdPartyIasData(body, queryParams);

  if (!response) {
    return [[], 0, ''];
  }

  const resp = response[0];
  if (!resp || !resp.rows) {
    return [[], 0, ''];
  }

  return [resp.rows.map(transformAnalytics), JSON.stringify(resp.rows).length, ''];
}

export async function sendIASEmail(
  body: IIASFirstAndThirdPartyRequestBody,
  queryParams: { [key: string]: any },
): Promise<[IIASFirstAndThirdPartyResponse?, Error?]> {
  return await v1SettingsPost('/email_ias_report', body, queryParams);
}
